import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLangNavigate } from '../../hooks/useLangNavigate';
import { useNotifications } from '../../hooks/useNotifications';
import NotificationItem from './NotificationItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBellSlash,
  faTimes,
  faCog,
  faEnvelopeOpen,
  faSpinner,
  faArrowRight, // Icono para el enlace "Ver todas"
} from '@fortawesome/free-solid-svg-icons';

const NotificationsPanel = ({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  // --- El hook ahora es más simple y no devuelve funciones de paginación ---
  const { notifications, markAsRead, isLoading } = useNotifications();

  const handleSettingsClick = () => {
    onClose();
    navigate('/settings/notifications');
  };

  const handleViewAllClick = () => {
    onClose();
    navigate('/notifications'); // Navegamos a la nueva página
  };

  const hasNotifications = notifications.length > 0;

  return (
    <div className="flex flex-col h-auto max-h-[90vh] w-full bg-white dark:bg-neutral-800 lg:rounded-xl shadow-card-hover overflow-hidden">
      <header className="flex-shrink-0 flex justify-between items-center p-4 border-b border-neutral-200 dark:border-neutral-700">
        <h3 className="font-display font-bold text-lg text-neutral-900 dark:text-white">
          {t('notifications.title')}
        </h3>
        <button
          onClick={onClose}
          className="lg:hidden w-8 h-8 flex items-center justify-center rounded-full text-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors"
          aria-label={t('notifications.close')}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </header>

      {/* --- El main ahora es más simple, sin scroll infinito --- */}
      <main className="overflow-y-auto">
        {isLoading ? (
          <div className="flex items-center justify-center p-10">
            <FontAwesomeIcon
              icon={faSpinner}
              spin
              className="text-2xl text-primary"
            />
          </div>
        ) : hasNotifications ? (
          <ul className="divide-y divide-neutral-100 dark:divide-neutral-700/50">
            {notifications.map((notif) => (
              <NotificationItem
                key={notif._id}
                notification={notif}
                onClose={onClose}
              />
            ))}
          </ul>
        ) : (
          <div className="flex flex-col items-center justify-center text-center px-6 py-12 text-neutral-500 dark:text-neutral-400">
            <FontAwesomeIcon
              icon={faBellSlash}
              className="text-4xl mb-4 text-neutral-400 dark:text-neutral-500"
            />
            <p className="font-semibold text-neutral-700 dark:text-neutral-300">
              {t('notifications.empty_state_title')}
            </p>
            <p className="text-sm mt-1">
              {t('notifications.empty_state_subtitle')}
            </p>
          </div>
        )}
      </main>

      {/* --- INICIO DE LA MODIFICACIÓN DEL FOOTER --- */}
      <footer className="flex-shrink-0 p-2 border-t border-neutral-200 dark:border-neutral-700">
        {hasNotifications ? (
          <button
            onClick={handleViewAllClick}
            className="w-full flex items-center justify-center gap-2 text-sm font-semibold text-primary dark:text-primary-light hover:bg-primary/10 transition-colors p-2 rounded-lg"
          >
            <span>{t('notifications.view_all')}</span>
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
        ) : (
          <div className="flex justify-between items-center p-2">
            <button
              onClick={markAsRead}
              className="flex items-center gap-2 text-sm text-neutral-600 dark:text-neutral-300 hover:text-primary dark:hover:text-primary-light transition-colors p-1 rounded-lg"
            >
              <FontAwesomeIcon icon={faEnvelopeOpen} />
            </button>
            <button
              onClick={handleSettingsClick}
              className="flex items-center gap-2 text-sm text-neutral-600 dark:text-neutral-300 hover:text-primary dark:hover:text-primary-light transition-colors p-1 rounded-lg"
            >
              <FontAwesomeIcon icon={faCog} />
            </button>
          </div>
        )}
      </footer>
      {/* --- FIN DE LA MODIFICACIÓN DEL FOOTER --- */}
    </div>
  );
};

export default NotificationsPanel;
